import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from "primeng/button";
import { TooltipModule } from 'primeng/tooltip';
import { EditLinks } from '../../../../@core/constants/edit-links';
import { BaseListCombinedService } from '../../../../@core/services/base-list-combined.service';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { NotificationService } from '../../../../@core/services/notification/notification.service';
import { DocumentLineItem, Operator, ProcessStepGroup, SearchInput } from '../../../../generated/generated-types';
import { ProductionProcessGroupService } from '../../../production/services/production-process-group.service';
import { DocumentLineItemService } from '../../services/document-line-item.service';
import { DocumentService } from '../../services/document.service';

type GroupedByLineItem = {
  lineItemId: string;
  lineItem: DocumentLineItem;
  groups: ProcessStepGroup[]
}

@Component({
  selector: 'app-formly-document-production-information',
  templateUrl: './formly-document-production-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AccordionModule,
    TranslatePipe,
    FormsModule,
    TooltipModule,
    ButtonModule,
  ]
})
export class FormlyDocumentProductionInformationComponent extends FieldType {

  groups = signal<GroupedByLineItem[]>([]);

  groupDoubleClickUrl = EditLinks.GROUP;

  constructor(
    private i18n: I18nService,
    notificationService: NotificationService,
    private ngxUiLoader: NgxUiLoaderService,
    private cdRef: ChangeDetectorRef,
    private baseListServices: BaseListCombinedService,
    private documentService: DocumentService,
    private psgService: ProductionProcessGroupService,
    private dliService: DocumentLineItemService) {
    super();
  }

  async load() {

    this.ngxUiLoader.start();

    this.groups.set([]);

    let docId = this.model.id;

    let si: SearchInput = {
      searchFilter: {
        rules: [
          {
            field: "source.documentId",
            operator: Operator.equal,
            value: docId
          },
        ]
      },
      take: 100
    };

    let dlis = await this.psgService.getItems(si).mapSingle(x => x.getProcessStepGroups).toPromise();

    for (let i = 0; i < dlis.items.length; i++) {
      const element = dlis.items[i];

      let existing = this.groups().find(x => x.lineItemId == element.sourceId);

      if (!existing) {
        existing = {
          lineItemId: element.sourceId,
          lineItem: element.source as DocumentLineItem,
          groups: []
        }
        this.groups.set([...this.groups(), existing]);
      }

      existing.groups.push(element as any); // TODO: fix type
    }

    this.groups.set([...this.groups()]);

    this.ngxUiLoader.stop();
  }

  async resetGroup(groupid: string) {
    let ok = confirm("Achtung - Reset durchführen?");

    if (ok) {
      this.ngxUiLoader.start();
      await this.psgService.resetProcessStepGroup(groupid);
      this.ngxUiLoader.stop();

      this.load();
    }
  }

}
